import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const catalogOverviewPlugin = createPlugin({
  id: 'catalog-overview',
  routes: { root: rootRouteRef },
});

/** What the catalog contains, mounted at /catalog-overview. */
export const CatalogOverviewPage = catalogOverviewPlugin.provide(
  createRoutableExtension({
    name: 'CatalogOverviewPage',
    component: () =>
      import('./components/CatalogOverviewPage').then(m => m.CatalogOverviewPage),
    mountPoint: rootRouteRef,
  }),
);
